"use strict";

angular.module('app.modals.deviceScanner', [])

    .controller('deviceScannerModalCtrl', ['$scope', 'close', 'deviceRoomPickerModal', 'f_Interval', 'f_User', 'xCenterConfig', 'API', '__Device', 'ENUM', '$filter', 'protocolPickerModal','$q',
        function ($scope, close, deviceRoomPickerModal, f_Interval, f_User, xCenterConfig, API, __Device, ENUM, $filter, protocolPickerModal,$q) {
            $scope.getLearnModeStateInterval = undefined;
            var _API = new API();
            $scope.NewDevices =  __Device.$collection();
            $scope.UpdatedDevices = __Device.$collection();
            $scope.isExpert = f_User.is('ExpertAccess');
            $scope.isAdmin = f_User.is('AdminAccess');
            $scope.singleSelectDT = false;

            $scope.DeviceTypesWithEncyrption = ENUM.getDeviceTypesByFilter(5);
            $scope.DeviceTypesWithAdress = ENUM.getDeviceTypesByFilter(6);

            $scope.DeviceTypes = ENUM.getDeviceTypesByFilter(7);
            $scope.DeviceTypesAll = ENUM.getDeviceTypesByFilter(1);

            var deviceEnumsFilter = {
                "FilterConfigurations":
                [
                    { "EnumName": "BufferSystemType", FilterProfile: 999 /* All */ },
                    { "EnumName": "PowermoduleFunctionType", FilterProfile: 999 /* All */ },
                    { "EnumName": "EMeterType", FilterProfile: 999 /* All */ },
                    { "EnumName": "UniversalModuleType", FilterProfile: 999 /* All */ },
                ]
            };
            _API.System.ResolveEnums(deviceEnumsFilter).$promise
                .then(function (data) {
                    $scope.customPropertiesSystemPossibleValues = {};
                    for (const key in data[0].Metadata) {
                        if (!Object.hasOwnProperty.call(data[0].Metadata, key)) continue;
                    
                        const elem = data[0].Metadata[key];
                        if (elem.EnumValueKey === "XBufferCombiPro" ||
                            elem.EnumValueKey === "XCenterPro" ||
                            elem.EnumValueKey === "Hydrobox" ||
                            elem.EnumValueKey === "XBufferFlexV1") {
                            $scope.customPropertiesSystemPossibleValues[key] = elem.DisplayName;
                        } else {
                            delete data[0].Metadata[key];
                        }
                    }

                    $scope.customPropertiesPowerFunctionPossibleValuesWithHydrobox = {};
                    $scope.customPropertiesPowerFunctionPossibleValues = {};
                    for (const key in data[1].Metadata) {
                        if (!Object.hasOwnProperty.call(data[1].Metadata, key)) continue;
                        
                        const elem = data[1].Metadata[key];
                        $scope.customPropertiesPowerFunctionPossibleValuesWithHydrobox[key] = elem.DisplayName;
                        if (elem.EnumValueKey !== 'StorageSystem') {
                            $scope.customPropertiesPowerFunctionPossibleValues[key] = elem.DisplayName;
                        }
                    }

                    $scope.customPropertiesEMeterTypePossibleValues = {};
                    for (const key in data[2].Metadata) {
                        if (!Object.hasOwnProperty.call(data[2].Metadata, key)) continue;
                    
                        const elem = data[2].Metadata[key];
                        $scope.customPropertiesEMeterTypePossibleValues[key] = elem.DisplayName;
                    }

                    $scope.customPropertiesUniversalModuleTypePossibleValues = {};
                    for (const key in data[3].Metadata) {
                        if (!Object.hasOwnProperty.call(data[3].Metadata, key)) continue;
                    
                        const elem = data[3].Metadata[key];
                        $scope.customPropertiesUniversalModuleTypePossibleValues[key] = elem.DisplayName;
                    }
                });

            // prepare device types for manual search
            for (var i = 0; i < $scope.DeviceTypesWithAdress.length; ++i) {
                if ($filter('filter')($scope.DeviceTypes, { $pk: $scope.DeviceTypesWithAdress[i].$pk }).length > 0) {
                    $scope.DeviceTypes[i]['withAdress'] = true;
                } else {
                    var newDeviceType = $scope.DeviceTypesWithAdress[i];
                    newDeviceType['withAdress'] = true;
                    $scope.DeviceTypes.push(newDeviceType);
                }
            }

            $scope.getDeviceType = function (DeviceType) {

                var l = $filter('filter')($scope.DeviceTypesAll, {'$pk': DeviceType});
                return l.length > 0 ? l[0] : {};
            };

            $scope.isDeviceWithCustomSystemOrPowerFunctionProperties = function(device) {
                if (device.DeviceType === 95) {
                    return true;
                }
                return false;
            };
            $scope.isDeviceHeatingCircuit = function(device) {
                if (device.DeviceType === 96) {
                    return true;
                }
                return false;
            };
            $scope.isDeviceWithCustomEMeterTypeProperties = function(device) {
                if (device.DeviceType === 105
                    || device.DeviceType === 110
                    || device.DeviceType === 111
                    || device.DeviceType === 112
                    || device.DeviceType === 113) {
                    return true;
                }
                return false;
            };


            $scope.customPropertiesSystemDdlChanged = function(returnParams) {
                returnParams.params.$UI.chosenValueCustomPropertiesSystemDdl = returnParams.value.toString();
                returnParams.params.$UI.chosenValueCustomPropertiesPowerFunctionDdl = '-1';
                returnParams.params.$UI.add = false;
            };
            $scope.customPropertiesPowerFunctionDdlChanged = function(returnParams) {
                returnParams.params.$UI.chosenValueCustomPropertiesPowerFunctionDdl = returnParams.value.toString();
                returnParams.params.$UI.add = false;
            };
            $scope.customPropertiesEMeterTypeDdlChanged = function(returnParams) {
                returnParams.params.$UI.chosenValueCustomPropertiesEMeterTypeDdl = returnParams.value.toString();
            };
            $scope.customPropertiesUniversalModuleTypeDdlChanged = function(returnParams) {
                returnParams.params.$UI.chosenValueCustomPropertiesUniversalModuleTypeDdl = returnParams.value.toString();
            };

            $scope.canCheckNewDeviceToBeSaved = function(newDevice) {
                if ($scope.isDeviceWithCustomSystemOrPowerFunctionProperties(newDevice)) {
                    if (newDevice.$UI.chosenValueCustomPropertiesSystemDdl !== "-1" && newDevice.$UI.chosenValueCustomPropertiesPowerFunctionDdl !== "-1") {
                        if (!newDevice.$UI.add) {
                            newDevice.$UI.add = true;
                            newDevice.CustomProperties = {
                                'WizardAnswer': JSON.stringify(
                                    {
                                        $type: 'BMS.Shared.Wizard.WizardAnswerBufferSystem, BMS.Shared',
                                        BufferSystemType: +newDevice.$UI.chosenValueCustomPropertiesSystemDdl,
                                        PowermoduleFunctionType: +newDevice.$UI.chosenValueCustomPropertiesPowerFunctionDdl
                                    })
                            }
                        } else {
                            newDevice.$UI.add = false;
                            delete newDevice.CustomProperties;
                        }
                    } else {
                        newDevice.$UI.add = false;
                    }
                } 
                else if ($scope.isDeviceWithCustomEMeterTypeProperties(newDevice)) {
                    if (newDevice.$UI.chosenValueCustomPropertiesEMeterTypeDdl !== "-1") {
                        if (!newDevice.$UI.add) {
                            newDevice.$UI.add = true;
                            newDevice.CustomProperties = {
                                'WizardAnswer': JSON.stringify(
                                    {
                                        $type: 'BMS.Shared.Wizard.WizardAnswerEMeterB24, BMS.Shared',
                                        Type: +newDevice.$UI.chosenValueCustomPropertiesEMeterTypeDdl,
                                    })
                            }
                        } else {
                            newDevice.$UI.add = false;
                            delete newDevice.CustomProperties;
                        }
                    } else {
                        newDevice.$UI.add = false;
                    }
                } 
                else if ($scope.isDeviceHeatingCircuit(newDevice)) {
                    if (newDevice.$UI.chosenValueCustomPropertiesUniversalModuleTypeDdl !== "-1") {
                        if (!newDevice.$UI.add) {
                            newDevice.$UI.add = true;
                            newDevice.CustomProperties = {
                                'WizardAnswer': JSON.stringify(
                                    {
                                        $type: 'BMS.Shared.Wizard.WizardAnswerUniversalModule, BMS.Shared',
                                        ModuleType: +newDevice.$UI.chosenValueCustomPropertiesUniversalModuleTypeDdl,
                                    })
                            }
                        } else {
                            newDevice.$UI.add = false;
                            delete newDevice.CustomProperties;
                        }
                    } else {
                        newDevice.$UI.add = false;
                    }
                }
                else {
                    newDevice.$UI.add = !newDevice.$UI.add;
                }
            }

            $scope.searchStyle = 'automatic';
            $scope.learnModeEnabled = false;
            $scope.showLearnedInDevices = false;
            $scope.manualModeOptions = {};

            $scope.hasEncryption = function (d) {
                if (!d) return false;
                return $filter('filter')($scope.DeviceTypesWithEncyrption, {$pk: parseInt(d)}).length > 0;
            };

            $scope.hasAddress = function (d) {
                if (!d) return false;
                return $filter('filter')($scope.DeviceTypesWithAdress, { $pk: parseInt(d) }).length > 0;
            };

            $scope.setMode = function (a) {
                // change search mode
                $scope.searchStyle = a;
                // clear previously added devices
                $scope.NewDevices =  __Device.$collection([]);
                // end the search if it was started
                if ($scope.learnModeEnabled) {
                     $scope.learnModeEnabled = false;
                    _API.Device.SetLearnModeEnabled({
                        LearnModeEnabled: false,
                        Protocol: -1
                    });
                }
                // unregister search interval
                if ($scope.getLearnModeStateInterval) {
                    f_Interval.unregisterIntervalByAppId($scope.getLearnModeStateInterval);
                    $scope.getLearnModeStateInterval = undefined;
                }
                $scope.buildList();
            };

            $scope.isNewDeviceType = function (a, b) {
                if (b == undefined) return true;
                if (a == undefined) return true;
                return !(a == b);
            };

            function setCustomMessage(newDevice) {
                if ($scope.isDeviceWithCustomSystemOrPowerFunctionProperties(newDevice)) {
                    newDevice.$UI.chosenValueCustomPropertiesSystemDdl = "-1";
                    newDevice.$UI.chosenValueCustomPropertiesPowerFunctionDdl = "-1";
                }
                if ($scope.isDeviceWithCustomEMeterTypeProperties(newDevice)) {
                    newDevice.$UI.chosenValueCustomPropertiesEMeterTypeDdl = "-1";
                }
                if ($scope.isDeviceHeatingCircuit(newDevice)) {
                    newDevice.$UI.chosenValueCustomPropertiesUniversalModuleTypeDdl = "-1";
                }
            }

            $scope.triggerLearnMode = function () {
                if (!$scope.learnModeEnabled) {
                    //prepare learnModeParams
                    $scope.NewDevices =  __Device.$collection([]);
                    var options = angular.copy($scope.manualModeOptions);
                    if ($scope.searchStyle === 'automatic') {
                        options = undefined;
                    } else if ($scope.searchStyle === 'manually') {
                        if (!options['DeviceType']) {
                            alert('please choose a device Type');
                            return;
                        }

                        options['DeviceType'] = options['DeviceType'][0]['$pk'];
                        if (!$scope.hasEncryption(options['DeviceType'])) {
                            options['Encrypted'] = false;
                        }

                        if (!$scope.hasAddress(options['DeviceType'])) {
                            options['DeviceAddress'] = 0;
                        }else{
                            // alert(options['DeviceAddress'].substr(0,2));

                                options['DeviceAddress'] = parseInt(options['DeviceAddress'],16);

                        }
                    }

                    // start learn mode
                    $scope.learnModeEnabled = true;
                    _API.Device.SetLearnModeEnabled({
                        Protocol: -1,
                        LearnModeEnabled: true,
                        Options: options
                    }).$promise.then(function () {
                        // register interval for getting new devices
                        $scope.getLearnModeStateInterval = f_Interval.registerInterval({
                            'AppId': 'interval.deviceScannerModal.getLearnModeState',
                            delay: xCenterConfig.interval.learnModeState,
                            fn: function () {
                                // add new device to newDevice-list
                                var promise = $q.defer();
                                __Device.$getNew().$then(
                                    function (data) {

                                        data.updatedDevices.forEach(device => {
                                            const foundDevices = $scope.UpdatedDevices.filter(origDevice => device.DeviceId === origDevice.DeviceId);
                                            if (foundDevices.length === 0) {
                                                const newDevice = __Device
                                                                    .$buildRaw(device)
                                                                    .$dispatch("build-view-datapoints");
                                                $scope.UpdatedDevices.push(newDevice);
                                            }
                                        });

                                        // new devices are added seperatly to old ones
                                        for (var i = 0; i < data.length; ++i) {
                                            var newDevice = data[i];
                                            newDevice.$UI = { add: false };
                                            newDevice.$UI.isParent = newDevice.ParentDeviceId === null || newDevice.ParentDeviceId === '00000000-0000-0000-0000-000000000000';
                                            setCustomMessage(newDevice);
                                            $scope.NewDevices.addIfNotExist(newDevice);

                                        }
                                        // $scope.NewDevices.$orderBy(['+DeviceType', '+Name']);
                                    $scope.buildList();

                                    promise.resolve();
                                });
                                return promise.promise;
                            }
                        }, true);
                    });
                } else {
                    $scope.learnModeEnabled = false;
                    // stop learn mode
                    _API.Device.SetLearnModeEnabled({
                        LearnModeEnabled: false,
                        Protocol: -1
                    });
                    f_Interval.unregisterInterval(f_Interval.getIntervalByAppId($scope.getLearnModeStateInterval).Interval);
                    $scope.getLearnModeStateInterval = undefined;
                }
            };

            $scope.openCloseLearnedInDevices = () => {
                $scope.showLearnedInDevices = !$scope.showLearnedInDevices;
            }

            $scope.setProtocolForDevice = function (d) {
                protocolPickerModal().then(function (modal) {
                    modal.close.then(function (result) {
                        if (result) {
                            d.Protocol = result['EnumValueKey'];
                        }

                    });
                });
            };

            $scope.setDeviceTypeForDevice = function (d) {

                var f = {
                    DeviceType: {
                        list: ENUM.getDeviceTypesByFilter(1),
                        selectable: 'single',
                        selected: [d.DeviceType]
                    },
                    title: 'DEVICE_SelectDeviceTypeForDevice_Modal_Title'
                };

                deviceRoomPickerModal(f).then(function (modal) {
                    modal.close.then(function (data) {
                        if (data) {
                            d.DeviceType = data['DeviceType'][0]['$pk'];
                            $scope.buildList();
                        }
                    });
                });
            };

            $scope.buildList = function(){
                $scope.newDevicesDeviceTypes = [];
                for(var i = 0; i < $scope.NewDevices.length; i++)
                {
                    if($scope.newDevicesDeviceTypes.indexOf($scope.NewDevices[i].DeviceType) === -1)
                    {
                        $scope.newDevicesDeviceTypes.push($scope.NewDevices[i].DeviceType);
                    }
                }
            }

            $scope.addDeviceToManualList = function () {


                var f = {
                    DeviceType: {
                        list: $scope.DeviceTypesAll,
                        selectable: 'single'
                    },
                    title: 'DEVICE_SelectDeviceTypeForDevice_Modal_Title'
                };

                deviceRoomPickerModal(f).then(function (modal) {
                    modal.close.then(function (data) {

                        if (data) {

                            var d = {
                                $UI: {expertMode: true},
                                DeviceType: data['DeviceType'][0]['$pk'],
                                Name: "",
                                ParentDeviceId: "00000000-0000-0000-0000-000000000000",
                                SoftwareVersion: "",
                                ParentMenuEntryId: "",
                                Protocol: "",
                                Address: ""
                            };

                            if (!$scope.NewDevices) {
                                $scope.NewDevices = __Device.$collection();
                            }

                            var dev = __Device.$buildRaw(d);
                            dev.$UI.expertMode = true;
                            setCustomMessage(dev);
                            $scope.NewDevices.$add(dev);
                            $scope.buildList();
                        }
                    });
                });


            };

            $scope.hasCheckedDevices = function(){
                if ($scope.NewDevices) {
                    return $filter('filter')($scope.NewDevices,{$UI:{add:true}},true).length > 0;
                } else {
                    return false;
                }
            };

            $scope.setRoomForDevice = function (device) {
                var f = {
                    MenuEntry: {
                        emptyRooms: true,
                        emptyRoomsButton: true,
                        selectable: 'single'
                    },
                    saveOnSelect: true,
                    title: 'DEVICE_SelectRoomForDevice_Modal_Title'
                };

                deviceRoomPickerModal(f).then(function (modal) {
                    modal.close.then(function (data) {
                        if (data) {
                            device.ParentMenuEntryId = data.MenuEntry[0].MenuEntryId;
                            device.$UI.Room = data.MenuEntry[0];
                        }
                    });
                });
            };

            $scope.save = function () {
                $scope.$emit('loading-start');
                // unregister interval
                if ($scope.getLearnModeStateInterval) {
                    f_Interval.unregisterInterval(f_Interval.getIntervalByAppId($scope.getLearnModeStateInterval).Interval);
                }
                // sort new devices by ParentDeviceId
                $scope.NewDevices.$orderBy(['+ParentDeviceId']);
                var parentDeviceList = [];
                var childDeviceList = [];
                for (var i = 0; i < $scope.NewDevices.length; ++i) {
                    if ($scope.NewDevices[i].$UI.add) {
                        if($scope.NewDevices[i].$UI.isParent) {
                            var newParentDevice = angular.copy($scope.NewDevices[i]);
                            parentDeviceList.push(newParentDevice.$add().$then(function (addedParentDevice) {
                                // after successfully added, prepare child device list
                                var newChildDevices = $scope.NewDevices.getAllChildrenOf(addedParentDevice);
                                for (var j = 0; j < newChildDevices.length; ++j) {
                                    for (var k = 0; k < $scope.NewDevices.length; ++k) {
                                        if (newChildDevices[j].DeviceId === $scope.NewDevices[k].DeviceId && $scope.NewDevices[k].$UI.add) {
                                            var newChildDevice = angular.copy($scope.NewDevices[k]);
                                            childDeviceList.push(newChildDevice.$add().$asPromise());
                                        }
                                    }
                                }
                            }).$asPromise());
                        }
                    }
                }

                if(parentDeviceList.length > 0) {
                    // add parent devices
                    $q.all(parentDeviceList).then(function () {
                        // add child devices if existing
                        if (childDeviceList.length > 0) {
                            $q.all(childDeviceList).then(function() {
                                $scope.$emit('loading-stop');
                                close(true);
                            });
                        } else {
                            $scope.$emit('loading-stop');
                            close(true);
                        }
                    });
                } else {
                    // build new child device list if no parents exist
                    for (var i = 0; i < $scope.NewDevices.length; ++i) {
                        if ($scope.NewDevices[i].$UI.add) {
                            var newChildDevice = angular.copy($scope.NewDevices[i]);
                            childDeviceList.push(newChildDevice.$add().$asPromise());
                        }
                    }
                    // execute rest request for adding new devices
                    if (childDeviceList.length > 0) {
                        $q.all(childDeviceList).then(function() {
                            $scope.$emit('loading-stop');
                            close(true);
                        });
                    } else {
                        $scope.$emit('loading-stop');
                        close(true);
                    }
                }
            };

            $scope.close = function () {
                if ($scope.getLearnModeStateInterval) {
                    f_Interval.unregisterIntervalByAppId($scope.getLearnModeStateInterval);
                }
                close();
            };

            $scope.NewDevices1 = [{
                "DeviceId": "7da9ebeb-dd7e-4873-8cf6-a7f2a9191031",
                "Protocol": 3,
                "PortAddress": "/dev/ttyO2",
                "SoftwareVersion": "1",
                "Address": "0x002D7075",
                "HomeServerSenderAddress": "0xFFFFFFFF",
                "Name": "EnOcean Doppelschalter (F60201)",
                "Serial": "2977909",
                "ParentMenuEntryId": null,
                "ParentDeviceId": "00000000-0000-0000-0000-000000000000",
                "DeviceType": 26,
                "DeviceOptions": [],
                "VisualizationDatapoints": null,
                "IsSynced": false,
                "IsOffline": null,
                "IsDisabled": null,
                "ConfigVersion": null,
                "Flags": 0
            }];
        }
    ])

    .factory('deviceScannerModal', ['API', 'ModalService', function (API, ModalService) {
        return function (onClose) {
            return ModalService.showModal({
                templateUrl: "views/modals/deviceScanner.html",
                controller: 'deviceScannerModalCtrl'
            }).then(function (modal) {
                modal.close.then(function (data) {
                    var _API = new API();
                    _API.Device.SetLearnModeEnabled({
                        LearnModeEnabled: false,
                        Protocol: -1
                    });
                    onClose(data);
                });
            });
        }
    }]);